export default __webpack_public_path__ + "static/logoActividad-1b363fab982ad8bbe696a8b9f21dfe5d.png";